export default "__VITE_ASSET__RDdYFJRV__"